import AutoSelectWarningInfo from './AutoSelectWarningInfo';

export default AutoSelectWarningInfo;
